<template>
  <span :class="'value' + (items.length > 0 ? ` ${notEmptyClass}` : '')">
    <span v-if="items.length === 0">0</span>
    <span
      v-for="item in items"
      :key="item.currency"
      class="d-block w-100"
    >
      {{ item.sum }} {{ $currencySymbol(item.currency) }}
    </span>
  </span>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    notEmptyClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    items () {
      if (this.list.length === 0) {
        return []
      }
      const currencies = this.currenciesList(this.list)

      const result = []
      for (const currency of currencies) {
        result.push({
          currency: currency,
          sum: this.list.filter(i => i.currency === currency).reduce((a, b) => a + (parseFloat(b.price) || 0), 0)
        })
      }

      return result
    }
  },
  methods: {
    currenciesList (itemList) {
      const currencies = itemList.reduce((a, b) => {
        if (a.indexOf(b.currency) === -1) {
          a.push(b.currency)
        }
        return a
      }, [])

      return currencies
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
